export type TSortDirection = "asc" | "desc";

export type TWithProperty<K extends string, T> = {
    [P in K]: T;
};

export const createSortByNumberPropertyComparator = <
    K extends string,
    T extends TWithProperty<K, number>,
>(
    property: K,
    direction: TSortDirection = "asc",
) => {
    return (a: T, b: T): number => {
        const multiplier = direction === "asc" ? 1 : -1;
        return (a[property] - b[property]) * multiplier;
    };
};

export const createSortByStringPropertyComparator = <
    K extends string,
    T extends TWithProperty<K, string>,
>(
    property: K,
    direction: TSortDirection = "asc",
) => {
    return (a: T, b: T): number => {
        const multiplier = direction === "asc" ? 1 : -1;
        return a[property].localeCompare(b[property]) * multiplier;
    };
};
